import { render, staticRenderFns } from "./SUPAOrganisms.vue?vue&type=template&id=15cf96fc&scoped=true&"
import script from "./SUPAOrganisms.vue?vue&type=script&lang=ts&"
export * from "./SUPAOrganisms.vue?vue&type=script&lang=ts&"
import style0 from "./SUPAOrganisms.vue?vue&type=style&index=0&id=15cf96fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf96fc",
  null
  
)

export default component.exports